module.exports = __webpack_public_path__ + "img/sld_mfm_og_b1_dark.bf2090b0.svg";